import React from 'react';

import * as Variant from '../layout/Variant';
import AccountingDashboard from './Accounting';
import AdOpsDashboard from './AdOps';
import CollabaryDashboard from './Collabary';
import LeadDashboard from './Lead';
import PCDashboard from './PC';
import SalesBackofficeDashboard from './SalesBackoffice';

const Dashboard = props => {
  return (
    <>
      <Variant.Accounting>
        <AccountingDashboard {...props} />
      </Variant.Accounting>
      <Variant.AdOps>
        <AdOpsDashboard {...props} />
      </Variant.AdOps>
      <Variant.Lead>
        <LeadDashboard {...props} />
      </Variant.Lead>
      <Variant.PC>
        <PCDashboard {...props} />
      </Variant.PC>
      <Variant.SalesBackoffice>
        <SalesBackofficeDashboard {...props} />
      </Variant.SalesBackoffice>
      <Variant.Collabary>
        <CollabaryDashboard {...props} />
      </Variant.Collabary>
    </>
  );
};

export default Dashboard;
